import { render, staticRenderFns } from "./escuela.vue?vue&type=template&id=7acff783&"
import script from "./escuela.vue?vue&type=script&lang=js&"
export * from "./escuela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports